(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
/*document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.collection-carousel');
  const leftControl = document.querySelector('.carousel-control-collections.left');
  const rightControl = document.querySelector('.carousel-control-collections.right');
  let currentIndex = 0;

  function updateCarousel(direction) {
    const items = carousel.getElementsByClassName('carousel-item-collection');
    if (!items.length) return;

    const scrollWidth = items[0].clientWidth + 5; // Largeur de l'élément plus le gap
    if (direction === 'next') {
      currentIndex = Math.min(currentIndex + 1, items.length - 1);
    } else if (direction === 'prev') {
      currentIndex = Math.max(currentIndex - 1, 0);
    }

    carousel.scrollLeft = currentIndex * scrollWidth;
    updateControlOpacity();
  }

  function updateControlOpacity() {
    const tolerance = 5; // Marge d'erreur en pixels
    const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth - tolerance;

    leftControl.style.opacity = carousel.scrollLeft > tolerance ? 1 : 0.2;
    rightControl.style.opacity = carousel.scrollLeft < maxScrollLeft ? 1 : 0.2;
  }

  carousel.addEventListener('scroll', updateControlOpacity);

  leftControl.addEventListener('click', () => updateCarousel('prev'));
  rightControl.addEventListener('click', () => updateCarousel('next'));

  // Initialise l'opacité des flèches lors du chargement
  updateControlOpacity();
});*/

document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.collection-carousel');

  carousels.forEach(function(carousel) {
    const leftControl = carousel.parentNode.querySelector('.carousel-control-collections.left');
    const rightControl = carousel.parentNode.querySelector('.carousel-control-collections.right');
    let currentIndex = 0;

    function updateCarousel(direction) {
      const items = carousel.getElementsByClassName('carousel-item-collection');
      if (!items.length) return;

      const scrollWidth = items[0].clientWidth + 5; // Largeur de l'élément plus le gap
      if (direction === 'next') {
        currentIndex = Math.min(currentIndex + 1, items.length - 1);
      } else if (direction === 'prev') {
        currentIndex = Math.max(currentIndex - 1, 0);
      }

      carousel.scrollLeft = currentIndex * scrollWidth;
      updateControlOpacity();
    }

    function updateControlOpacity() {
      const tolerance = 5; // Marge d'erreur en pixels
      const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth - tolerance;

      leftControl.style.opacity = carousel.scrollLeft > tolerance ? 1 : 0.2;
      rightControl.style.opacity = carousel.scrollLeft < maxScrollLeft ? 1 : 0.2;
    }

    carousel.addEventListener('scroll', updateControlOpacity);

    leftControl.addEventListener('click', () => updateCarousel('prev'));
    rightControl.addEventListener('click', () => updateCarousel('next'));

    // Initialise l'opacité des flèches lors du chargement
    updateControlOpacity();
  });
});



  } catch(e) { console.error(e); }
})();
})();
